import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import "../styles/global.css";
const appName = "Logigate";
import * as React from "react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import "dayjs/locale/pt";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar";
// O kit Tailwind. O painel já não tem páginas Mantine com rota: saíram os estilos do Mantine e
// o `mantine-fixes.css` (apagado). As poucas páginas sem rota, à espera de decisão, ainda
// importam o Mantine, mas nunca abrem.
import "../../css/app.css";
import moment from "moment";
import "moment/dist/locale/pt";
import { TemaProvider } from "@/Logigate/ui/tema";
import { definirCorDoPortal } from "@/Logigate/ui/cores";
import { vigiarVisitasDepressaDemais } from "@/Logigate/utils/pedidosDepressaDemais";

moment().locale("pt");

// A cor do Logigate (o azul do logótipo) logo no arranque: as páginas fora do casco (escolher a
// empresa, criar, os ecrãs de bloqueio) também a usam; o casco volta a pô-la ao montar.
definirCorDoPortal("logigate");

// O `HongaProvider` estendia o dayjs com estes dois (o `fromNow()` das listas e o `calendar()`):
// sem ele, ficam aqui.
dayjs.locale("pt");
dayjs.extend(relativeTime);
dayjs.extend(calendar);

// Uma visita do Inertia que bate no limite de pedidos (429) mostra «Estás a ir depressa demais…».
vigiarVisitasDepressaDemais();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: async (name) => {
        const p = await resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob("./Pages/**/*.tsx"),
        );
        return p;
    },
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(
            // O modo claro/escuro sem o Mantine: a mesma chave (`vite-ui-theme`) e a mesma omissão
            // («system») do `HongaProvider` e do blade, que já pôs a classe no `<html>` antes de pintar.
            <TemaProvider omissao="system">
                <App {...props} />
            </TemaProvider>,
        );
    },
    progress: {
        color: "#1709D5",
        showSpinner: true,
    },
});
